/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-17 23:06:56
 * @LastEditTime: 2021-09-16 09:16:45
 * @LastEditors: Please set LastEditors
 */
import axios from 'axios';
import router from '../router';
import ElementUI from 'element-ui'
let service = axios.create({
  headers: {}
})


let loading = null //定义loading变量

//开始 加载loading
let startLoading = () => {
  loading = ElementUI.Loading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })
}
//结束 取消loading加载
let endLoading = () => {
  loading.close()
}

if (process.env.NODE_ENV === 'development') {
  axios.defaults.baseURL = "//localhost:4000/v1/api"
} else {
  axios.defaults.baseURL = "//server.mspace.org/v1/api"
}


// 添加请求拦截器
service.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  startLoading()
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 添加响应拦截器
service.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  endLoading();
  let data = response.data
  if (data.errno) {
    ElementUI.Message(data.errmsg)
  }
  if (response.data.code == "40202") { }
  return data
}, function (error) {
  // 对响应错误做点什么
  endLoading()
  return Promise.reject(error)
})

export default service



// WEBPACK FOOTER //
// ./src/plugins/axios.js